export default __webpack_public_path__ + "static/media/profileImg.6324f636.jpg";